/** Root component: providers, then the router. */
import { BrowserRouter } from 'react-router-dom';
import { AdminAuthProvider } from './context/AdminAuthContext.jsx';
import { ToastProvider, ToastRegion } from './context/ToastContext.jsx';
import { AdminRoutes } from './routes/AdminRoutes.jsx';
import { ErrorBoundary } from './components/ErrorBoundary.jsx';

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ToastProvider>
          <AdminAuthProvider>
            <AdminRoutes />
            <ToastRegion />
          </AdminAuthProvider>
        </ToastProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
